export const breakpoints = {
  sm: 428,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  fhd: 1512,
  qhd: 1920,
};

// Helper function to check if current screen size is above a breakpoint
export const isAbove = (breakpoint) => {
  return window.innerWidth > breakpoints[breakpoint];
};

// Helper function to check if current screen size is below a breakpoint
export const isBelow = (breakpoint) => {
  return window.innerWidth <= breakpoints[breakpoint];
};
